export const leadsStrings = {
  title: "Bandeja de leads",
  subtitle:
    "Audita personas que llegaron por Meta, WhatsApp IA o inbound. Convierte a cliente y asigna ventor sin salir del detalle.",
  searchPlaceholder: "Buscar por nombre o teléfono",
  lifecycleLabel: "Estado",
  lifecycleAll: "Todos (leads y clientes)",
  lifecycleLead: "Lead",
  lifecycleCustomer: "Cliente",
  sourceLabel: "Origen",
  sourceAll: "Todos los orígenes",
  sources: {
    meta_form: "Meta form",
    whatsapp_lead_conversation: "WhatsApp IA",
    whatsapp_inbound: "WhatsApp inbound",
    manual: "Manual",
    webinar: "Webinar",
  } as Record<string, string>,
  refresh: "Actualizar",
  emptyTitle: "Sin leads en este filtro",
  emptyHint: "Prueba otro origen o rango de fechas. Los ingresos nuevos se etiquetan automáticamente.",
  loadError: "No se pudo cargar la bandeja de leads.",
  convert: "Convertir a cliente",
  convertConfirmTitle: "¿Convertir este lead a cliente?",
  convertConfirmBody: "Pasará a lifecycle cliente. Puedes asignar un ventor en el mismo paso.",
  convertSuccess: "Lead convertido a cliente.",
  convertError: "No se pudo convertir el lead.",
  openDetail: "Ver ficha",
  openSession: "Conversación IA",
  colName: "Nombre",
  colPhone: "Teléfono",
  colSources: "Orígenes",
  colLifecycle: "Estado",
  colAssignee: "Asesor",
  colScore: "Score IA",
  colCreated: "Alta",
  colActions: "Acciones",
  unassigned: "Sin asignar",
  promoted: "Ya es cliente",
  leadStripTitle: "Resumen lead",
  assignOptional: "Asignar ventor (opcional)",
}
